import { logEvent } from "firebase/analytics";
import { analytics } from "../config/firebase-config";

class CommonUtil {    
    public static logEvent(eventName: string, eventParams?: { [key: string]: any }) {
        if (window.location.host.startsWith('www')) {
            logEvent(analytics, eventName, eventParams);
        }
    }

    public static getUtcDate() {
        const now = new Date();
        const timezoneOffset = (now.getTimezoneOffset() * 60 * 1000);
        now.setTime(now.getTime() + timezoneOffset);
        return now;
    }

    public static getLocalDateTimeString(dateStr: string) {
        const date = new Date(dateStr);
        const 연 = date.getFullYear();
        const 월 = String(date.getMonth() + 1).padStart(2, '0');
        const 일 = String(date.getDate()).padStart(2, '0');
        const 요일 = ['일', '월', '화', '수', '목', '금', '토'][date.getDay()];
        const 오전 = date.getHours() >= 12 ? '오후' : '오전';
        const 시 = String(date.getHours() % 12).padStart(2, '0');
        const 분 = String(date.getMinutes()).padStart(2, '0');
        return `${연}/${월}/${일} (${요일}) ${오전} ${시}:${분}`;
    }
}

export default CommonUtil;
